import { render } from "./DockMusicIcon.vue?vue&type=template&id=d11ef6a4&scoped=true"
import script from "./DockMusicIcon.vue?vue&type=script&lang=js"
export * from "./DockMusicIcon.vue?vue&type=script&lang=js"

import "./DockMusicIcon.vue?vue&type=style&index=0&id=d11ef6a4&scoped=true&lang=css"

import exportComponent from "/var/www/service/service-cp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d11ef6a4"]])

export default __exports__